// 長頁的段落錨點（VMS UX 評審第二輪 R2-P2-4：我的帳號 › 安全性、通知）：頁頂一列連結，點了捲到那一段（網址不換、不觸發換頁）。
import { useTranslation } from 'react-i18next';

export function PageAnchors({ items }: { items: { id: string; label: string }[] }) {
  const { t } = useTranslation();
  return (
    <nav className="page-anchors" aria-label={t('common.on_this_page')} data-testid="page-anchors">
      <span className="muted small">{t('common.on_this_page')}</span>
      {items.map((x) => (
        <a
          key={x.id}
          href={`#${x.id}`}
          className="chip"
          onClick={(e) => {
            e.preventDefault();
            document.getElementById(x.id)?.scrollIntoView?.({ block: 'start', behavior: 'smooth' });
          }}
        >
          {x.label}
        </a>
      ))}
    </nav>
  );
}
